<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">

            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar</a>

                    <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Usuários</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>

        </div>
        <div id="pnlista">


            <!-- Botão Novo Cliente -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-person-plus"></i> Novo Usuário
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pesquisa cliente  -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="">pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite
                                </label>
                                <select class="form-select form-control" v-model="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabela de Clientes -->
            <div class="card">
                <div class="card-body">
                    <!-- Tabela de Clientes com EasyDataTable -->
                    <EasyDataTable :headers="headers" :items="lstusuarios" :pagination="false" hide-footer border-cell
                        empty-message="Nenhum dado encontrado"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id }">

                            <a @click="mtdalterar(id)" class="btn btn-sm btn-warning">
                                <i class="bi bi-pencil-square"></i>
                            </a>
                            <button style="margin-left: 15px;" type="button" class="btn btn-sm btn-danger"
                                @click="mtdexcluir(id)">
                                <i class="bi bi-trash"></i>
                            </button>

                        </template>

                        <template #item-nome="{ nome }">
                            {{ nome }}
                        </template>


                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">

                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros"
                                    :items-per-page="pqtdregistros" :max-pages-shown="2" v-model="pagina_atual" />



                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pncadastro">
            <!-- Cadastro de Clientes -->
            <div class="card">
                <div class="card-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="edid">Código</label>
                                    <input type="text" v-model="vid" class="form-control" id="edid" disabled>
                                </div>
                            </div>

                            <div class="col-lg-10">
                                <div class="form-group">
                                    <label for="ednome">Nome</label>
                                    <input type="text" v-model="vnome" :disabled="ativadesativa" class="form-control"
                                        id="ednome">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Empresa padrão:</span>
                                <select id="cbempresa" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                    style="width:100%;" v-model="vidempresa">
                                </select>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="ednome">Login</label>
                                    <input type="text" v-model="vlogin" :disabled="ativadesativa" class="form-control"
                                        id="edlogin">
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="ednome">Senha</label>
                                    <input type="password" v-model="vsenha" :disabled="ativadesativa"
                                        class="form-control" id="edsenha">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 col-md-10 col-sm-12">

                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12">
                                <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-info">
                                    <i class="bi bi-edit"></i> Gravar
                                </button>
                                <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-warning">
                                    <i class="bi bi-edit"></i> Alterar
                                </button>
                                <button v-show="opcrud == 3" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-danger">
                                    <i class="bi bi-edit"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);


// @ is an alias to /src
import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';
import  Maskinput  from "@/components/MaskInput.vue";


import { ref } from "vue";

const onClickHandler = (page) => {
    console.log(page);
};

const pagina_atual = ref(1);



export default {
    name: 'Usuarios',

    data() {
        return {

            //variaveis do cadastro 
            opcrud: 0,
            vid: 0,
            vnome: '',
            vlogin: '',
            vsenha: '',
            vidempresa: null,

            modulo: 'USUÁRIOS',
            descop: '',

            //paginação
            pqtd_total_registros: 10,
            pagina_atual: 1,
            pqtdregistros: 10,
            pqtd_paginas: 0,


            //filtros
            pfiltro: 1,
            pconteudo: '',

            ativadesativa: false,

            headers: [
                {
                    text: 'Ações', value: 'acoes', width: 80,
                    cellClassName: 'text-uppercase'
                },
                { text: 'Nome', value: 'nome', sortable: true },
            ],


            lstusuarios: [

            ]

        }
    },
    components: {
        EasyDataTable,
        Maskinput

    },

    methods: {
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : ' and u.id=' + this.pconteudo;
            } else {
                rfiltro = this.pconteudo === '' ? '' : ' and u.upper(nome) like upper("' + this.pconteudo + '%")';
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op', valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro', valor: filtro }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/usuarios.php');
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'limit', valor: vself.pqtdregistros },
                { parametro: 'offset', valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/usuarios.php');
            retorno.then(function (response) {
                vself.lstusuarios = JSON.parse(JSON.stringify(response.data));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstusuarios = [];
                vself.$loading.hide();
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;

        },
        resetarDados() {
            this.vid = '';
            this.vnome = '';
            this.vsenha = '';
            this.vlogin = '';
        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },
        mtdnovo() {


            this.descop = 'INCLUSÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(1);

        },
        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();

        },

        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).
                then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = ' and u.id=' + id;
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'limit', valor: 1 },
                { parametro: 'offset', valor: 0 },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/usuarios.php');
            retorno.then(function (response) {
                vself.mtdigualarcampos(response.data[0]);
                if (parseInt(vself.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {

            console.log(id);

            this.descop = 'ALTERAÇÃO'

            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);

        },
        mtdexcluir(id) {

            this.descop = 'EXCLUSÃO'

            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);

        },
        mtdigualarcampos(registro) {
            this.vid    = registro.id;
            this.vnome  = registro.nome;
            this.vsenha = registro.senha;
            this.vlogin = registro.login;

            this.vidempresa = registro.idfilialpadrao;

            var deffilial     = new Option(registro.nomefilial, registro.idfilialpadrao, true, true);
            $('#cbempresa').append(deffilial).trigger('change');
        },
        mtdregistro() {
            let vself = this;
            let registrocrud = {
                'id': this.vid,
                'nome': this.vnome,
                'senha': this.vsenha,
                'login': this.vlogin,
                'idempresa': this.vidempresa


            };
            let parametros = [
                { parametro: 'op', valor: 'rotinacrud' },
                { parametro: 'opcrud', valor: vself.opcrud },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro', valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/usuarios.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },

    },
    computed: {
        validou() {
            return this.vnome == '' || this.vsenha == '' || this.vlogin == '' || this.vidempresa === null

        }

    },
    mounted() {
        let vself = this;

        $loading.show()
        setTimeout(() => {

            this.$loading.hide()
            this.mtdexecutapesquisa();
        }
        , 1000)
        $('#pncadastro').hide();

        //selects da consulta
        $("#cbempresa").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfiliais ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidempresa = $("#cbempresa").val();
        });

        this.mtdexecutapesquisa()
    },
    watch: {
        pagina_atual(val) {
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>
.pagination-container {
    display: flex;

    column-gap: 10px;
}

.col-opcoes {
    width: 60px !important;
}

.paginate-buttons {


    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #13534a;

    border: 1px solid #13534a;

    color: white;
}

.active-page:hover {
    background-color: #13534a;
}
</style>